import { ChessGame, idxToCoord, pieceColor } from '../../engine.js';
import { XiangqiGame, xqIdxToCoord, xqPieceColor } from '../../xiangqi-engine.js';
import { CaroGame, caroPieceSide } from '../../caro-engine.js';

export function pieceColorForGame(gameType, piece) {
  if (gameType === 'chess') return pieceColor(piece);
  if (gameType === 'xiangqi') return xqPieceColor(piece);
  if (gameType === 'caro') return caroPieceSide(piece);
  return null;
}

export function coordForGame(gameType, idx) {
  if (gameType === 'chess') return idxToCoord(idx);
  if (gameType === 'xiangqi') return xqIdxToCoord(idx);
  if (gameType === 'caro') {
    const row = Math.floor(idx / 15);
    const col = idx % 15;
    return String.fromCharCode(65 + col) + String(row + 1);
  }
  return String(idx);
}

export function sideNameForGame(gameType, color) {
  if (gameType === 'xiangqi') return color === 'w' ? 'Đỏ' : 'Đen';
  if (gameType === 'caro') return color === 'w' ? 'X' : 'O';
  return color === 'w' ? 'Trắng' : 'Đen';
}

export function createGameEngine(gameType) {
  if (gameType === 'chess') return new ChessGame();
  if (gameType === 'xiangqi') return new XiangqiGame();
  if (gameType === 'caro') return new CaroGame();
  return null;
}
